export default __webpack_public_path__ + "static/curriculum-guide-preview-4-1509583629ed8cce8da84679f04a41de.jpg";